import { createContext, useRef, useState, useEffect, useCallback } from "react";

import homeImageMain from "../Assets/homeImageMain.png";

export const MyContext = createContext({});

const images = [homeImageMain];

const getInitialTheme = () => {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem("dn-theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

export const MyContextProvider = ({ children }) => {
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const [theme, setTheme] = useState(getInitialTheme);

  const serviceRef = useRef();
  const contactUsRef = useRef();
  const appointmentRef = useRef();
  const aboutUsRef = useRef();
  const processRef = useRef();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem("dn-theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  useEffect(() => {
    const loadImages = async () => {
      const promises = images.map(
        (src) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = reject;
          })
      );

      await Promise.all(promises);
      setAllImagesLoaded(true);
    };

    loadImages();
  }, []);

  return (
    <MyContext.Provider
      value={{
        serviceRef,
        contactUsRef,
        appointmentRef,
        allImagesLoaded,
        aboutUsRef,
        processRef,
        theme,
        toggleTheme,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
